import { wrapperBuilder } from './build';
import { TARGET_MODES } from './others';

const staticsRegister = wrapperBuilder.getStaticsGeneratorsRegisterInstance();

staticsRegister.addStaticProp('TARGET_MODES', TARGET_MODES);
